var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "property-base",
    { attrs: { label: _vm.label.text, forInput: _vm.label.for } },
    [
      _vm._l(_vm.newValue, function(mid, idx) {
        return [
          _c("div", { key: idx, staticClass: "row form-group" }, [
            _c(
              "div",
              { staticClass: "col-10" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.resource(
                            "JourneyBuilder_FilterSettings_ContentTool"
                          )
                        ) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c(
                        "input-group",
                        {
                          staticClass: "h-100",
                          attrs: { icon: "fa fa-percent" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: mid.percentage,
                                expression: "mid.percentage",
                                modifiers: { number: true }
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "number",
                              min: _vm.rules.percentage.minValue,
                              max: _vm.rules.percentage.maxValue
                            },
                            domProps: { value: mid.percentage },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  mid,
                                  "percentage",
                                  _vm._n($event.target.value)
                                )
                              },
                              blur: function($event) {
                                return _vm.$forceUpdate()
                              }
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-8" },
                    [
                      _c(
                        "input-group",
                        {
                          staticClass: "h-100",
                          attrs: { icon: "far fa-newspaper" }
                        },
                        [
                          _c(
                            "v-select",
                            {
                              staticClass: "form-control",
                              attrs: {
                                options: _vm.options,
                                disabled: !_vm.canWrite,
                                searchable: "",
                                filterable: "",
                                taggable: "",
                                "close-on-select": ""
                              },
                              model: {
                                value: _vm.newValue[idx].contentId,
                                callback: function($$v) {
                                  _vm.$set(_vm.newValue[idx], "contentId", $$v)
                                },
                                expression: "newValue[idx].contentId"
                              }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "no-options" },
                                slot: "no-options"
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                !_vm.$v.newValue.$each.$iter[idx].percentage.minValue
                  ? _c("min-value-error-message", {
                      attrs: {
                        "field-name": "Percentage",
                        "min-value": _vm.rules.percentage.minValue
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.newValue.$each.$iter[idx].percentage.maxValue
                  ? _c("max-value-error-message", {
                      attrs: {
                        "field-name": "Percentage",
                        "max-value": _vm.rules.percentage.maxValue
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-2 d-flex flex-column" }, [
              _vm.newValue.length !== 1
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-danger mt-auto",
                      class: { disabled: !_vm.canWrite },
                      on: {
                        click: function($event) {
                          return _vm.removeMidAt(idx)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-minus" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              idx + 1 === _vm.newValue.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      class: [_vm.newValue.length === 1 ? "mt-auto" : "mt-1"],
                      on: { click: _vm.addMid }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                : _vm._e()
            ])
          ])
        ]
      }),
      _vm._v(" "),
      !_vm.$v.newValue.hasFullPercentage
        ? _c("error-message", {
            attrs: {
              message: _vm.resource(
                "JourneyBuilder_ContentSettings_PercentageSum_ErrorMessage"
              )
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }